import { useGlobalContext } from "../../context/context";
import { useEffect, useState } from "react";
import Loader from "../../components/loaders/Loader";

const DepositHistory = () => {
  const { setIsUser, setUserToken, userToken, baseURL, resetPage } =
    useGlobalContext();
  const [allTransactions, setAllTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [trigger, setTrigger] = useState(0);

  useEffect(() => {
    resetPage(`Deposit History`);
    // eslint-disable-next-line
  }, []);

  // RESTORE USER DASHBOARD LINKS AFTER REFRESH
  useEffect(() => {
    if (window.localStorage.getItem(`userDetails`)) {
      setIsUser(true);
    }
  }, [setIsUser]);

  // GET USER TOKEN FROM LOCAL STORAGE
  useEffect(() => {
    setUserToken(JSON.parse(window.localStorage.getItem(`userToken`)));
  }, [setUserToken]);

  // FETCH ALL TRANSACTIONS FUNCTION
  const fetchAllTransactions = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${baseURL}/transaction/all`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      });
      const data = await response.json();
      console.log(data);
      setLoading(false);
      setAllTransactions(data.allTransactions);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  // FETCH ALL USER TRANSACTIONS ONLY WHEN USER TOKEN HAS BEEN LOADED FROM THE LOCAL STORAGE
  useEffect(() => {
    setTimeout(() => {
      setTrigger(1);
      if (userToken) {
        fetchAllTransactions();
      }
    }, 500);
    // eslint-disable-next-line
  }, [trigger]);

  return (
    <section className='deposit-history'>
      <div className='history-block'>
        {/* TABLE CONTAINING USER INFORMATION GOTTEN FROM THE API */}
        <h1>Deposit History</h1>
        {loading ? (
          <Loader />
        ) : allTransactions ? (
          <div className='table'>
            {allTransactions.reverse().map((transaction) => {
              const { amount, date, reference, status, _id: id } = transaction;
              return (
                <div className='table-data' key={id}>
                  <div className='div'>
                    <h4>Date</h4>
                    <p>{date}</p>
                  </div>
                  <div className='div'>
                    <h4>Narration</h4>
                    <p>deposit</p>
                  </div>
                  <div className='div'>
                    <h4>Reference</h4>
                    <p>{reference}</p>
                  </div>
                  <div className='div'>
                    <h4>Amount</h4>
                    <p>{amount}</p>
                  </div>
                  <div className='div'>
                    <h4>Status</h4>
                    <p
                      className={
                        status === `pending`
                          ? `pending`
                          : status === `approved`
                          ? `approved`
                          : status === `failed`
                          ? `failed`
                          : null
                      }
                    >
                      {status}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className='no-transaction'>
            <h3>No transaction history</h3>
          </div>
        )}
      </div>
    </section>
  );
};

export default DepositHistory;
